/**
 * @author Fernando FH
 */


import {
    APP_CONFIGURATION
} from "@/core/AppConfiguration";

const ApiConfiguration = {
    WEB_SERVICE_HOST: APP_CONFIGURATION.WEB_SERVICE_HOST,
    WEB_SERVICE_PORT: APP_CONFIGURATION.WEB_SERVICE_PORT,
    WEB_SERVICE_PROTOCOL: APP_CONFIGURATION.WEB_SERVICE_PROTOCOL,
    WEB_SERVICE_UNSECURE_PATH: process.env.NODE_ENV === 'production' ? '/ecews/app/' : '/ecewsdev/',
    WEB_SERVICE_SECURE_PATH: process.env.NODE_ENV === 'production' ? '/ecews/app/sc/' : '/ecewsdev/app/sc/',
    CONTEXT_BACKEND: process.env.NODE_ENV === 'production' ? '/ecews/' : '/ecewsdev/'
};

export const PATH_BACKNED = "@/dcm/";

export const SECURE_ENDPOINT = ApiConfiguration.WEB_SERVICE_PROTOCOL.concat(
    ApiConfiguration.WEB_SERVICE_HOST,
    ApiConfiguration.WEB_SERVICE_PORT,
    ApiConfiguration.WEB_SERVICE_SECURE_PATH
);
export const UNSECURE_ENDPOINT = ApiConfiguration.WEB_SERVICE_PROTOCOL.concat(
    ApiConfiguration.WEB_SERVICE_HOST,
    ApiConfiguration.WEB_SERVICE_PORT,
    ApiConfiguration.WEB_SERVICE_UNSECURE_PATH
);